import {useState, useEffect} from 'react'
import { Box, Grid, Paper, Stack, Tab, Tabs } from '@mui/material'

import useFetch 			from '../../api/api';
import useExternalFetch 	from '../../api/apiExternal';
import config 				from '../../common/Config';
import DividendsBox 		from './components/DividendsBox';
import DividendsCalendar 	from './components/DividendsCalendar';
import Loading from '../../components/Loading';

function Dividends() {

	const [dividends, setDividends] 					= useState();
	const [portfolioSummary, setPortfolioSummary] 		= useState(); 
	const [currentTabIndex, setCurrentTabIndex] 		= useState(0);
	const [todaysExchangeRate, setTodaysExchangeRate] 	= useState();
	const [isLoading, setIsLoading] 					= useState(true);

	const privateFetch = useFetch();
	const externalFetch = useExternalFetch();

	useEffect(() => {

		let options = {
			method : 'GET',
			headers : {
				'content-type' : 'application/json; charset=utf-8',
			}
		}

		privateFetch(config.apiUrl +"/api/portfolio/dividends", options)
		.then((data) => data.json())
		.then(async (data) => {

			await getPortfolioSummary()

			await getExchangeRate()
			.then(exchangeRates => {

				let dividends = []

				data.map((dividend, index) => {

					let earnings    = parseFloat(dividend.earnings)
					let irpf        = parseFloat(dividend.irpf)

					if ( dividend.market === 'US') {
						earnings    = earnings * parseFloat(exchangeRates[dividend.month].rate)
						irpf        = irpf * parseFloat(exchangeRates[dividend.month].rate)
					}

					dividends.push({
						key				: index,
						stockTicker     : dividend.stockTicker,
						market          : dividend.market,
						month           : dividend.month,
						day             : dividend.day,
						earnings        : earnings,
						irpf            : irpf,
						originalValue   : dividend.earnings
					})
				})

				setDividends(dividends)
			})

			setIsLoading(false)
		})

	},[])

	//Carne leão é o rendimento de todos convertido pelo dólar de compra do último dia útil da primeira quinzena do mês anterior ao recebimento. 
	async function getExchangeRate() {
		let exchangeDays = ['']
		let exchangeRate = ['']

		// Cria um array com a data do ultimo dia util de cada quinzena
		for (let month=1;month<=12;month++) {
			let endDay = 15
			let currentMonth    = ('0'+ (month === 1 ? 12 : month - 1)).slice(-2)
			let currentYear     = (month === 1 ? parseInt(new Date().getFullYear()) - 1 : parseInt(new Date().getFullYear()))

			let date = new Date(currentYear +'-'+ currentMonth + '-'+ endDay +' 00:00:00')

			while (date.getDay() === 0 || date.getDay() === 6 ) { 
				endDay--;
				date = new Date(currentYear +'-'+ currentMonth + '-'+ endDay +' 00:00:00')
			}

			exchangeDays.push(date)
		}

		// Verifica a cotacao de cada um dos dias do array criado acima
		let options = {
			method : 'GET',
			headers : {
				'content-type' : 'application/json; charset=utf-8',
			}
		}

		let startingYear = parseInt(new Date().getFullYear()) - 1
		
		await externalFetch("https://financialmodelingprep.com/api/v3/historical-price-full/USDBRL?from="+ startingYear +"-12-01", options)
		.then((data) => data.json())
		.then((data) => {
			// Seta a cotacao do dia de hoje
			setTodaysExchangeRate(data.historical[0].close)

			// Monta o array com as cotacoes de cada mes
			for (let day=1;day<exchangeDays.length;day++) {
				let currentRate = data.historical.filter(exchange => exchange.date === exchangeDays[day].toISOString().substring(0,10))[0]

				if (!currentRate) {
					currentRate = data.historical[0]
				}

				exchangeRate.push({
					date : exchangeDays[day],
					rate : currentRate.close
				})
			}
		})

		return exchangeRate
	}

	async function getPortfolioSummary() { 
		let results;
		let options = {
			method : 'GET',
			headers : {
				'content-type' : 'application/json; charset=utf-8',
			}
		}      

		results = await privateFetch(config.apiUrl +"/api/portfolio/summary/ACAO", options)
		.then((data) => data.json())

		setPortfolioSummary(results)
	}

	const addProps = (index) => {
		return {
		  id: `simple-tab-${index}`,
		  'aria-controls': `simple-tabpanel-${index}`,
		};
	}

	const handleTabChange = (e, tabIndex) => {
		setCurrentTabIndex(tabIndex);
	};    

	if (isLoading) return <Loading />

	return (
		<Paper bgcolor={"white"} sx={{marginLeft:2, marginRight: 2}}>
		<Stack>
			<Box sx={{borderBottom:1, borderColor: "divider"}}>
				<Tabs value={currentTabIndex} onChange={handleTabChange} >
					<Tab label="Visão Geral" {...addProps(0)} ></Tab>
					<Tab label="Calendário" {...addProps(1)} ></Tab>
				</Tabs>
			</Box>
			 
			 {currentTabIndex === 0 && (
				<Box>
					<Grid sx={{ flexGrow: 1 }} container spacing={2}>
						<Grid item xs={12}>
							<Grid container justifyContent="center" spacing={2} p={2}>
								<Grid item xs={12} md={6}>{(dividends 
									? <DividendsBox
										dividends={dividends}
										market={'BR'}
										portfolioSummary={portfolioSummary}
										exchangeRate={todaysExchangeRate}
									/>
									: null
								)}</Grid>
								<Grid item xs={12} md={6}>{(dividends
									? <DividendsBox
										dividends={dividends}
										market={'US'}
										portfolioSummary={portfolioSummary}
										exchangeRate={todaysExchangeRate}
									/> 
									: null
								)}</Grid>
							</Grid>
						</Grid>                
					</Grid> 
				</Box>
			 )}

			{currentTabIndex === 1 && (
				<DividendsCalendar dividends={dividends} portfolioSummary={portfolioSummary}/>
			)}             
		</Stack>
		</Paper>		
	)
}

export default Dividends